import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { clearErrorAction } from 'store/actions/login';
import { MoneyInput } from 'components/common/MoneyInput';
import { TextInput } from 'components/common/TextInput';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import { Z_INDEX } from 'enums/form-enums';

export const Input = ({
  placeholder,
  type,
  onChange,
  hasValue,
  hasError,
  defaultValue,
  value,
  onFocus,
  onBlur,
  isMoney,
  zIndex,
  errorColor,
}) => {
  const [isHidden, setIsHidden] = useState(true);
  const requestStatus = useSelector((state) => state.status);
  const dispatch = useDispatch();

  const handleClick = () => {
    if (type === 'password') {
      setIsHidden(!isHidden);
    }
  };

  const handleFocus = () => {
    if (hasError || requestStatus.hasError) {
      dispatch(clearErrorAction());
    }
  };

  return (
    <Input.InputContainer hasError={hasError}>
      <Input.StyledLabel>{hasValue ? placeholder : ''}</Input.StyledLabel>
      {isMoney ? (
        <MoneyInput
          defaultValue={defaultValue}
          value={value}
          hasError={hasError}
          hasValue={hasValue}
          placeholder={placeholder}
          type="number"
          onChange={onChange}
          handleFocus={onFocus}
          isHidden={isHidden}
          handleBlur={onBlur}
          errorColor={errorColor}
        />
      ) : (
        <TextInput
          defaultValue={defaultValue}
          value={value}
          hasError={hasError}
          hasValue={hasValue}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          onFocus={handleFocus}
          isHidden={isHidden}
          handleFocus={handleFocus}
          handleClick={handleClick}
          zIndex={zIndex}
          errorColor={errorColor}
        />
      )}
    </Input.InputContainer>
  );
};
Input.InputContainer = styled.div`
  border: none;
  margin-top: -1px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: ${FONTS.default};
  position: relative
  &:first-child {
    margin-top: 32px;
  }
`;

Input.StyledLabel = styled.label`
  font-size: 10px;
  line-height: 11px;
  position: absolute;
  opacity: 0.5;
  max-height: 11px;
  padding: 0;
  margin-left: 25px;
  margin-top: 10px;
  z-index: ${Z_INDEX.INPUT};
  color: ${(props) =>
    props.hasError && !props.errorColor ? COLORS.primaryErrorText : COLORS.secondayErrorText};
`;

Input.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  hasValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasError: PropTypes.bool,
  isMoney: PropTypes.bool,
  defaultValue: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorColor: PropTypes.string,
};

export default Input;
